module.exports = __webpack_public_path__ + "static/media/sfx_animal_flamingo.d5d42e78.mp3";